export { defaultLoggerConfig, type GarnishLoggerConfig, initLogger, logger } from './logger';
